import { render } from "./GaugeComponent.vue?vue&type=template&id=bd3373d0"
import script from "./GaugeComponent.vue?vue&type=script&lang=js"
export * from "./GaugeComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__